"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
require("./userRequests.scss");
const userHistorySlice_1 = require("../../../../redux/slices/userHistorySlice");
const react_redux_1 = require("react-redux");
const userSlice_1 = require("../../../../redux/slices/userSlice");
const common_1 = require("../../../../utils/common");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const get_1 = __importDefault(require("lodash/get"));
const moment_1 = __importDefault(require("moment"));
const adminPagination_1 = __importDefault(require("../../../../shared/components/adminPagination/adminPagination"));
const svgIcons_1 = require("../../../../svgIcons");
const tableHead = [
    {
        key: "ID",
        value: "case_id"
    }, {
        key: "Event Date",
        value: "case_date"
    }, {
        key: "Case Name",
        value: "title"
    }, {
        key: "Request Type",
        value: "request_type"
    }, {
        key: "Case Type",
        value: "case_type"
    }, {
        key: "Role",
        value: "role"
    }, {
        key: "Payment",
        value: "price"
    }, {
        key: "Status",
        value: "status"
    }
];
class UserRequests extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            user_id: null,
            currentPage: 1,
            count: 0,
        };
        // search field filter
        this.handleInputSearch = (e) => {
            const val = e.target.value;
            if (val.length >= 3 || !val) {
                const { filter } = this.props.userHistory;
                const updatedFilter = cloneDeep_1.default(Object.assign(Object.assign({}, filter), { offset: parseInt(common_1.urlPrams("page")) - 1 || 0, user_id: this.props.user.id, q: val }));
                this.props.updateHistoryList(updatedFilter);
            }
        };
        // get user cases data
        this.getUserHistory = (event, page) => {
            this.props.getUserHistory(Object.assign(Object.assign({}, this.props.userHistory.filter), { offset: (page - 1), user_id: this.props.user.id }));
            this.setState({ currentPage: page });
        };
        // set pagination data object
        this.setPaginationData = () => {
            const { filter, itemsCount } = this.props.userHistory;
            const { currentPage } = this.state;
            const from = currentPage === 1 ? currentPage : (((currentPage - 1) || 1) * filter.limit) + 1;
            let to = currentPage === 1 ? filter.limit : (from + filter.limit) - 1;
            const count = Math.ceil(itemsCount / filter.limit);
            const total = itemsCount;
            if (to > itemsCount) {
                to = itemsCount;
            }
            return { from, to, count, currentPage, total, pageChange: this.getUserHistory };
        };
    }
    componentDidMount() {
        const id = common_1.urlPrams('id');
        if (isEmpty_1.default(this.props.user)) {
            this.props.getUserAllData(id);
        }
        this.props.getUserHistory(Object.assign(Object.assign({}, this.props.userHistory.filter), { user_id: id }));
    }
    getTableCell(row, val, key) {
        const { user } = this.props;
        let cell = get_1.default(row, val.value);
        console.log("row", row);
        switch (val.value) {
            case 'case_date':
                cell = cell === '' || !cell ? 'N/A' : (react_1.default.createElement("span", null,
                    moment_1.default(cell).format('DD MMM YYYY').toUpperCase(),
                    react_1.default.createElement("br", null),
                    moment_1.default(cell).utc(false).format('h:mm a').toUpperCase()));
                break;
            case 'role':
                cell = row.client === user.id ? 'AOR' : 'AA';
                break;
            case 'price':
                cell = cell || cell === 0 && row.price_info !== 'Contingency Basis' ? `$${cell}` : 'N/A';
                break;
            case 'status':
                cell = cell === '' ? 'N/A' : react_1.default.createElement("span", { className: `status ${cell.toLowerCase()}` }, cell);
        }
        return (react_1.default.createElement(core_1.TableCell, { key: key, className: "admin-cases-nowrap" }, cell));
    }
    render() {
        var _a;
        const { list, filter, itemsCount } = this.props.userHistory;
        // @ts-ignore
        // minor style fix for preloader
        (_a = document.querySelector('.v2-loader')) === null || _a === void 0 ? void 0 : _a.style.left = '100px';
        return (react_1.default.createElement(core_1.Box, { id: 'user-requests' },
            react_1.default.createElement(core_1.Box, { className: 'user-info' },
                react_1.default.createElement("div", { className: "title-wrapper" },
                    react_1.default.createElement("p", null, "Full Name:"),
                    react_1.default.createElement("p", null, "Email:")),
                react_1.default.createElement("div", { className: "info-wrapper" },
                    react_1.default.createElement("a", { target: '_blank', href: `#/profile-guest?id=${this.props.user.id}` }, this.props.user.name),
                    react_1.default.createElement("p", null, this.props.user.email))),
            react_1.default.createElement("div", { className: "search-pagination" },
                react_1.default.createElement("div", { className: "search-box" },
                    react_1.default.createElement("input", { type: "text", placeholder: "Search", onChange: (e) => this.handleInputSearch(e), id: "search-expert" }))),
            itemsCount > filter.limit && react_1.default.createElement(adminPagination_1.default, { data: this.setPaginationData() }),
            react_1.default.createElement(core_1.TableContainer, { className: "clearfix table-container" },
                react_1.default.createElement(core_1.Table, { "aria-label": "table", className: "table admin-panel-table table-history admin-wn-table" },
                    react_1.default.createElement(core_1.TableHead, { className: "admin-panel-table-thead" },
                        react_1.default.createElement(core_1.TableRow, null, tableHead.map((data, key) => {
                            return (react_1.default.createElement(core_1.TableCell, { className: data.value, key: key }, data.key));
                        }))),
                    list.length > 0 ? react_1.default.createElement(core_1.TableBody, { className: "admin-panel-table-tbody" }, list.map((row, key) => {
                        return (react_1.default.createElement(core_1.TableRow, { key: key }, tableHead.map((val, key) => this.getTableCell(row, val, key))));
                    })) :
                        react_1.default.createElement(core_1.Box, { className: 'icon-wrapper' },
                            react_1.default.createElement(svgIcons_1.NoCasesIcon, { className: 'icon' }),
                            react_1.default.createElement("p", null, "No results to show.")))),
            itemsCount > filter.limit && react_1.default.createElement(adminPagination_1.default, { data: this.setPaginationData() })));
    }
}
const mapStateToProps = (state) => {
    const { userHistory, user } = state;
    return {
        userHistory,
        user
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getUserAllData: (id) => dispatch(userSlice_1.getUserAllData(id, false)),
        getUserHistory: (data) => dispatch(userHistorySlice_1.getUserHistory(data)),
        updateHistoryList: (data) => dispatch(userHistorySlice_1.updateHistoryList(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UserRequests);
